import { render, staticRenderFns } from "./ThgBillingSelectionAffiliateItem.vue?vue&type=template&id=307fc942&"
import script from "./ThgBillingSelectionAffiliateItem.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingSelectionAffiliateItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports